const SOURCE_ID = "energy-balance";
const LAYER_ID = "energy-balance-circles";
const LABEL_LAYER_ID = "energy-balance-labels";

export const showEnergyBalance = (map: any, geojson: any) => {
	// Clear any existing energy balance layers first
	clearEnergyBalance(map);

	// Add the source
	map.addSource(SOURCE_ID, {
		type: "geojson",
		data: geojson
	});

	// Add circle layer sized by ds_total
	// Loss % = ((energy_value - ds_total) / energy_value) * 100
	// Green if <= 10%, red if > 10%
	map.addLayer({
		id: LAYER_ID,
		type: "circle",
		source: SOURCE_ID,
		paint: {
			"circle-radius": [
				"interpolate",
				["linear"],
				["get", "ds_total"],
				0, 4,
				1000, 8,
				10000, 14,
				100000, 22,
				1000000, 32
			],
			"circle-color": "transparent",
			"circle-opacity": 0,
			"circle-stroke-width": 5,
			"circle-stroke-color": [
				"case",
				[">",
					["*",
						["/",
							["-", ["get", "energy_value"], ["get", "ds_total"]],
							["get", "energy_value"]
						],
						100
					],
					10
				],
				"#c53030",
				"#276749"
			]
		}
	});

	// Add label layer showing loss percentage
	// Loss % = ((energy_value - ds_total) / energy_value) * 100
	map.addLayer({
		id: LABEL_LAYER_ID,
		type: "symbol",
		source: SOURCE_ID,
		layout: {
			"text-field": [
				"concat",
				[
					"to-string",
					[
						"round",
						[
							"*",
							[
								"/",
								["-", ["get", "energy_value"], ["get", "ds_total"]],
								["get", "energy_value"]
							],
							100
						]
					]
				],
				"%"
			],
			"text-size": 24,
			"text-offset": [0, -1.5],
			"text-anchor": "bottom",
			"text-allow-overlap": false
		},
		paint: {
			"text-color": "#1a202c",
			"text-halo-color": "#ffffff",
			"text-halo-width": 2
		}
	});
};

export const clearEnergyBalance = (map: any) => {
	if (map.getLayer(LABEL_LAYER_ID)) {
		map.removeLayer(LABEL_LAYER_ID);
	}
	if (map.getLayer(LAYER_ID)) {
		map.removeLayer(LAYER_ID);
	}
	if (map.getSource(SOURCE_ID)) {
		map.removeSource(SOURCE_ID);
	}
};
